import { Outlet } from "react-router-dom";

const LayoutRoute = () => {
    return (
        <>
            <Outlet />
        </>
    );
};

export default LayoutRoute;
